{
  "title": "Hold Person",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level enchantment",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a small, straight piece of iron)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Choose a humanoid that you can see within range. The target must succeed on a Wisdom saving throw or be paralyzed for the duration. At the end of each of its turns, the target can make another Wisdom saving throw. On a success, the spell ends on the target.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, you can target one additional humanoid for each slot level above 2nd. The humanoids must be within 30 feet of each other when you target them."
  ],
  "spellLists": ["bard", "cleric", "druid", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
